import { render } from "./masonry.vue?vue&type=template&id=580d1972"
import script from "./masonry.vue?vue&type=script&lang=js"
export * from "./masonry.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__